(function () {
  'use strict';

  const EVENT_NAME = 'ec:blog-search';
  const VIEW_PARAM = 'ec-blog-results';
  const DEFAULT_PER_PAGE = 12;

  class BlogState {
    static currentTag = '';
    static currentSort = 'relevance';
    static currentPage = 1;
    
    static normalizeString(str) {
      if (!str) return '';
      return String(str).toLowerCase().trim();
    }
  }

  function $(root, selector) {
    return root.querySelector(selector);
  }

  function isSearchUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      return u.pathname.includes('/search');
    } catch (e) {
      return String(url).includes('/search');
    }
  }

  function ensureViewParam(url, perPage) {
    const u = new URL(url, window.location.origin);
    if (!u.searchParams.get('view')) u.searchParams.set('view', VIEW_PARAM);
    if (perPage && !u.searchParams.get('per_page')) u.searchParams.set('per_page', String(perPage));
    return u.toString();
  }

  function buildSearchViewUrl(query, perPage) {
    const u = new URL('/search', window.location.origin);
    u.searchParams.set('type', 'article');
    u.searchParams.set('options[prefix]', 'last');
    u.searchParams.set('q', query);
    u.searchParams.set('view', VIEW_PARAM);
    if (perPage) u.searchParams.set('per_page', String(perPage));
    return u.toString();
  }

  function setLoading(container, isLoading) {
    if (!container) return;
    container.classList.toggle('is-loading', Boolean(isLoading));
    container.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function extractFragmentFromSearchHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('[data-ec-blog-results-fragment]')?.innerHTML || html;
  }

  async function fetchHtml(url, signal) {
    const res = await fetch(url, { signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!res.ok) throw new Error(String(res.status));
    return await res.text();
  }

  function setupSearchBars() {
    const roots = document.querySelectorAll('[data-ec-blog-search]');
    roots.forEach((root) => {
      if (root.hasAttribute('data-initialized')) return;
      root.setAttribute('data-initialized', 'true');

      const form = root.querySelector('form');
      const input = root.querySelector('input[type="search"]');
      if (!form || !input) return;

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const query = (input.value || '').trim();
        document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { query } }));
      });
    });
  }

  function setupResultLists() {
    const lists = document.querySelectorAll('[data-ec-blog-results]');
    lists.forEach((container) => {
      if (container.hasAttribute('data-initialized')) return;
      container.setAttribute('data-initialized', 'true');

      const body = container.querySelector('[data-ec-blog-results-body]');
      const perPage = parseInt(container.getAttribute('data-per-page') || String(DEFAULT_PER_PAGE), 10) || DEFAULT_PER_PAGE;
      let abortController = null;
      let activeMode = 'blog';

      async function loadSearch(query, urlOverride) {
        if (!body) return;
        if (abortController) abortController.abort();
        abortController = new AbortController();
        activeMode = 'search';
        setLoading(container, true);
        try {
          const url = urlOverride || buildSearchViewUrl(query, perPage);
          const html = await fetchHtml(url, abortController.signal);
          const fragment = extractFragmentFromSearchHtml(html);
          
          const fragmentDoc = new DOMParser().parseFromString(fragment, 'text/html');
          const fragmentGrid = fragmentDoc.querySelector('.ec-blog-results__grid');
          const fragmentPagination = fragmentDoc.querySelector('.ec-blog-results__pagination');
          
          const currentGrid = body.querySelector('.ec-blog-results__grid');
          const currentPagination = body.querySelector('.ec-blog-results__pagination');
          
          if (fragmentGrid && currentGrid) {
            currentGrid.innerHTML = fragmentGrid.innerHTML;
          }
          
          if (fragmentPagination && currentPagination) {
            currentPagination.innerHTML = fragmentPagination.innerHTML;
            currentPagination.style.display = 'none';
          } else if (currentPagination) {
            currentPagination.innerHTML = '';
            currentPagination.style.display = 'none';
          }
          
          BlogState.currentPage = 1;
          
          try {
            BlogManager.applyFilters();
            
            setTimeout(() => {
              BlogFiltering.init();
              BlogSorting.init();
              BlogPagination.init();
            }, 0);
          } catch (error) {
            console.error(error);
          }
        } catch (err) {
          if (err?.name !== 'AbortError') {
            body.innerHTML = '<div class="ec-blog-results__error">Não foi possível carregar os resultados. Tente novamente.</div>';
          }
        } finally {
          setLoading(container, false);
        }
      }

      async function loadBlogPage(url) {
        if (!body) return;
        if (abortController) abortController.abort();
        abortController = new AbortController();
        activeMode = 'blog';
        setLoading(container, true);
        try {
          const html = await fetchHtml(url, abortController.signal);
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextBody = doc.querySelector('[data-ec-blog-results-body]');
          if (nextBody) {
            const nextGrid = nextBody.querySelector('.ec-blog-results__grid');
            const nextPagination = nextBody.querySelector('.ec-blog-results__pagination');
            
            const currentGrid = body.querySelector('.ec-blog-results__grid');
            const currentPagination = body.querySelector('.ec-blog-results__pagination');
            
            if (nextGrid && currentGrid) {
              currentGrid.innerHTML = nextGrid.innerHTML;
            }
            
            if (nextPagination && currentPagination) {
              currentPagination.innerHTML = nextPagination.innerHTML;
              currentPagination.style.display = 'none';
            } else if (currentPagination) {
              currentPagination.innerHTML = '';
              currentPagination.style.display = 'none';
            }
            
            BlogState.currentPage = 1;
            
            try {
              BlogManager.applyFilters();
              
              setTimeout(() => {
                BlogFiltering.init();
                BlogSorting.init();
                BlogPagination.init();
              }, 0);
            } catch (error) {
              console.error(error);
            }
          }
        } catch (err) {
          if (err?.name !== 'AbortError') {
            body.innerHTML = '<div class="ec-blog-results__error">Não foi possível carregar os resultados. Tente novamente.</div>';
          }
        } finally {
          setLoading(container, false);
        }
      }

      document.addEventListener(EVENT_NAME, (e) => {
        const query = (e.detail?.query || '').trim();
        if (!query) {
          loadBlogPage(window.location.pathname + window.location.search);
          return;
        }
        loadSearch(query);
      });

      container.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (!link) return;
        if (!link.closest('.pagination-wrapper')) return;

        e.preventDefault();
        const href = link.getAttribute('href');
        if (!href) return;

        if (activeMode === 'search' || isSearchUrl(href)) {
          const url = ensureViewParam(href, perPage);
          loadSearch('', url);
        } else {
          loadBlogPage(href);
        }
      });
    });
  }

  class BlogSorting {
    static init() {
      this.initSortFilter();
    }

    static initSortFilter() {
      const button = document.getElementById('ec-blog-sort-button');
      const dropdown = document.getElementById('ec-blog-sort-dropdown');
      const modal = document.getElementById('ec-blog-sort-modal');
      const modalClose = document.getElementById('ec-blog-sort-modal-close');
      
      if (!button) {
        return;
      }
      
      if (button.hasAttribute('data-initialized')) {
        return;
      }
      
      button.setAttribute('data-initialized', 'true');

      const isMobile = () => window.innerWidth <= 749;
      const sortContainer = button.closest('[data-ec-blog-sort-filter]');

      const toggleDropdown = () => {
        if (isMobile()) {
          if (modal) {
            const isOpen = modal.getAttribute('aria-hidden') === 'false';
            if (isOpen) {
              modal.setAttribute('aria-hidden', 'true');
              document.body.style.overflow = '';
            } else {
              modal.setAttribute('aria-hidden', 'false');
              document.body.style.overflow = 'hidden';
            }
          }
        } else {
          if (dropdown) {
            const isOpen = button.getAttribute('aria-expanded') === 'true';
            if (isOpen) {
              button.setAttribute('aria-expanded', 'false');
              dropdown.setAttribute('hidden', '');
            } else {
              button.setAttribute('aria-expanded', 'true');
              dropdown.removeAttribute('hidden');
            }
          }
        }
      };

      const closeDropdown = () => {
        if (isMobile()) {
          if (modal) {
            modal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
        } else {
          if (dropdown) {
            dropdown.setAttribute('hidden', '');
          }
          button.setAttribute('aria-expanded', 'false');
        }
      };

      button.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleDropdown();
      });

      if (modalClose) {
        modalClose.addEventListener('click', closeDropdown);
      }

      if (modal) {
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            closeDropdown();
          }
        });
      }

      const selectOption = (value, label) => {
        const valueElement = document.getElementById('ec-blog-sort-value');
        if (valueElement) {
          valueElement.textContent = label;
        }
        
        if (dropdown) {
          const options = dropdown.querySelectorAll('.ec-blog-sort__option');
          options.forEach(opt => {
            opt.classList.remove('ec-blog-sort__option--selected');
            opt.setAttribute('aria-selected', 'false');
            if (opt.getAttribute('data-value') === value) {
              opt.classList.add('ec-blog-sort__option--selected');
              opt.setAttribute('aria-selected', 'true');
            }
          });
        }

        if (modal) {
          const modalOptions = modal.querySelectorAll('.ec-blog-sort__option');
          modalOptions.forEach(opt => {
            opt.classList.remove('ec-blog-sort__option--selected');
            opt.setAttribute('aria-selected', 'false');
            const checkbox = opt.querySelector('.ec-blog-sort__option-checkbox');
            if (checkbox) {
              checkbox.style.backgroundColor = '#FFFFFF';
              checkbox.style.borderColor = '#E8E8EE';
            }
            if (opt.getAttribute('data-value') === value) {
              opt.classList.add('ec-blog-sort__option--selected');
              opt.setAttribute('aria-selected', 'true');
              if (checkbox) {
                checkbox.style.backgroundColor = '#086EBB';
                checkbox.style.borderColor = '#086EBB';
              }
            }
          });
        }
        
        BlogState.currentSort = value;
        BlogState.currentPage = 1;
        closeDropdown();
        
        try {
          BlogManager.applyFilters();
        } catch (error) {
          console.error(error);
        }
      };

      if (dropdown) {
        dropdown.addEventListener('click', (e) => {
          const option = e.target.closest('.ec-blog-sort__option');
          if (!option) return;
          e.stopPropagation();
          const value = option.getAttribute('data-value') || 'relevance';
          const label = option.textContent.trim();
          selectOption(value, label);
        });
        
        const currentValue = BlogState.currentSort || 'relevance';
        const options = dropdown.querySelectorAll('.ec-blog-sort__option');
        options.forEach(option => {
          const optionValue = option.getAttribute('data-value') || 'relevance';
          if (optionValue === currentValue) {
            option.classList.add('ec-blog-sort__option--selected');
            option.setAttribute('aria-selected', 'true');
          }
        });
      }

      if (modal) {
        modal.addEventListener('click', (e) => {
          const option = e.target.closest('.ec-blog-sort__option');
          if (!option) return;
          e.stopPropagation();
          const value = option.getAttribute('data-value') || 'relevance';
          const label = option.querySelector('span:last-child')?.textContent.trim() || option.textContent.trim();
          selectOption(value, label);
        });
        
        const currentValue = BlogState.currentSort || 'relevance';
        const modalOptions = modal.querySelectorAll('.ec-blog-sort__option');
        modalOptions.forEach(option => {
          const optionValue = option.getAttribute('data-value') || 'relevance';
          if (optionValue === currentValue) {
            option.classList.add('ec-blog-sort__option--selected');
            option.setAttribute('aria-selected', 'true');
            const checkbox = option.querySelector('.ec-blog-sort__option-checkbox');
            if (checkbox) {
              checkbox.style.backgroundColor = '#086EBB';
              checkbox.style.borderColor = '#086EBB';
            }
          }
        });
      }

      document.addEventListener('click', function(e) {
        if (sortContainer && !sortContainer.contains(e.target)) {
          closeDropdown();
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          closeDropdown();
        }
      });
    }

    static sortCards(cards) {
      const sortType = BlogState.currentSort;

      if (sortType === 'relevance') {
        cards.sort((a, b) => {
          const aComments = parseInt(a.getAttribute('data-comments-count') || '0', 10);
          const bComments = parseInt(b.getAttribute('data-comments-count') || '0', 10);
          if (bComments !== aComments) {
            return bComments - aComments;
          }
          const aTime = parseInt(a.getAttribute('data-published-at') || '0', 10);
          const bTime = parseInt(b.getAttribute('data-published-at') || '0', 10);
          return bTime - aTime;
        });
        return cards;
      }

      if (sortType === 'newest') {
        cards.sort((a, b) => {
          const aTime = parseInt(a.getAttribute('data-published-at') || '0', 10);
          const bTime = parseInt(b.getAttribute('data-published-at') || '0', 10);
          return bTime - aTime;
        });
      } else if (sortType === 'oldest') {
        cards.sort((a, b) => {
          const aTime = parseInt(a.getAttribute('data-published-at') || '0', 10);
          const bTime = parseInt(b.getAttribute('data-published-at') || '0', 10);
          return aTime - bTime;
        });
      }

      return cards;
    }
  }

  class BlogFiltering {
    static init() {
      this.initTagFilter();
    }

    static initTagFilter() {
      const button = document.getElementById('ec-blog-tag-filter-button');
      const dropdown = document.getElementById('ec-blog-tag-filter-dropdown');
      const modal = document.getElementById('ec-blog-tag-filter-modal');
      const modalClose = document.getElementById('ec-blog-tag-filter-modal-close');
      
      if (!button) {
        return;
      }
      if (!dropdown && !modal) {
        return;
      }
      
      if (button.hasAttribute('data-initialized')) {
        return;
      }
      
      button.setAttribute('data-initialized', 'true');

      const isMobile = () => window.innerWidth <= 749;
      const filterContainer = button.closest('[data-ec-blog-tag-filter]');

      const toggleDropdown = () => {
        const mobile = isMobile();
        if (mobile) {
          if (modal) {
            const isOpen = modal.getAttribute('aria-hidden') === 'false';
            if (isOpen) {
              modal.setAttribute('aria-hidden', 'true');
              document.body.style.overflow = '';
            } else {
              modal.setAttribute('aria-hidden', 'false');
              document.body.style.overflow = 'hidden';
            }
          }
        } else {
          if (dropdown) {
            const isOpen = button.getAttribute('aria-expanded') === 'true';
            if (isOpen) {
              button.setAttribute('aria-expanded', 'false');
              dropdown.setAttribute('hidden', '');
            } else {
              button.setAttribute('aria-expanded', 'true');
              dropdown.removeAttribute('hidden');
            }
          }
        }
      };

      const closeDropdown = () => {
        if (isMobile()) {
          if (modal) {
            modal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
        } else {
          if (dropdown) {
            dropdown.setAttribute('hidden', '');
          }
          button.setAttribute('aria-expanded', 'false');
        }
      };

      button.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleDropdown();
      });

      if (modalClose) {
        modalClose.addEventListener('click', closeDropdown);
      }

      if (modal) {
        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            closeDropdown();
          }
        });
      }

      const selectOption = (value, label) => {
        const valueElement = document.getElementById('ec-blog-tag-filter-value');
        if (valueElement) {
          valueElement.textContent = value ? label : 'Todas as publicações';
        }
        
        if (dropdown) {
          const options = dropdown.querySelectorAll('.ec-blog-tag-filter__option');
          options.forEach(opt => {
            opt.classList.remove('ec-blog-tag-filter__option--selected');
            opt.setAttribute('aria-selected', 'false');
            if (opt.getAttribute('data-value') === value) {
              opt.classList.add('ec-blog-tag-filter__option--selected');
              opt.setAttribute('aria-selected', 'true');
            }
          });
        }

        if (modal) {
          const modalOptions = modal.querySelectorAll('.ec-blog-tag-filter__option');
          modalOptions.forEach(opt => {
            opt.classList.remove('ec-blog-tag-filter__option--selected');
            opt.setAttribute('aria-selected', 'false');
            const checkbox = opt.querySelector('.ec-blog-tag-filter__option-checkbox');
            if (checkbox) {
              checkbox.style.backgroundColor = '#FFFFFF';
              checkbox.style.borderColor = '#E8E8EE';
            }
            if (opt.getAttribute('data-value') === value) {
              opt.classList.add('ec-blog-tag-filter__option--selected');
              opt.setAttribute('aria-selected', 'true');
              if (checkbox) {
                checkbox.style.backgroundColor = '#086EBB';
                checkbox.style.borderColor = '#086EBB';
              }
            }
          });
        }
        
        BlogState.currentTag = value;
        BlogState.currentPage = 1;
        closeDropdown();
        
        try {
          BlogManager.applyFilters();
        } catch (error) {
          console.error(error);
        }
      };

      if (dropdown) {
        dropdown.addEventListener('click', (e) => {
          const option = e.target.closest('.ec-blog-tag-filter__option');
          if (!option) return;
          e.stopPropagation();
          const value = option.getAttribute('data-value') || '';
          const label = option.textContent.trim();
          selectOption(value, label);
        });
        
        const currentValue = BlogState.currentTag || '';
        const options = dropdown.querySelectorAll('.ec-blog-tag-filter__option');
        options.forEach(option => {
          const optionValue = option.getAttribute('data-value') || '';
          if (optionValue === currentValue) {
            option.classList.add('ec-blog-tag-filter__option--selected');
            option.setAttribute('aria-selected', 'true');
          }
        });
      }

      if (modal) {
        modal.addEventListener('click', (e) => {
          const option = e.target.closest('.ec-blog-tag-filter__option');
          if (!option) return;
          e.stopPropagation();
          const value = option.getAttribute('data-value') || '';
          const label = option.querySelector('span:last-child')?.textContent.trim() || option.textContent.trim();
          selectOption(value, label);
        });
        
        const currentValue = BlogState.currentTag || '';
        const modalOptions = modal.querySelectorAll('.ec-blog-tag-filter__option');
        modalOptions.forEach(option => {
          const optionValue = option.getAttribute('data-value') || '';
          if (optionValue === currentValue) {
            option.classList.add('ec-blog-tag-filter__option--selected');
            option.setAttribute('aria-selected', 'true');
            const checkbox = option.querySelector('.ec-blog-tag-filter__option-checkbox');
            if (checkbox) {
              checkbox.style.backgroundColor = '#086EBB';
              checkbox.style.borderColor = '#086EBB';
            }
          }
        });
      }

      document.addEventListener('click', function(e) {
        if (filterContainer && !filterContainer.contains(e.target)) {
          closeDropdown();
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          closeDropdown();
        }
      });
    }
  }

  class BlogPagination {
    static init() {
      const container = document.querySelector('[data-ec-blog-results]');
      if (!container) {
        return;
      }
      
      const pagination = container.querySelector('.ec-blog-results__pagination');
      if (!pagination) {
        return;
      }
      
      if (pagination.hasAttribute('data-listeners-attached')) {
        return;
      }
      
      pagination.setAttribute('data-listeners-attached', 'true');
      
      pagination.addEventListener('click', (e) => {
        e.preventDefault();
        const button = e.target.closest('a.pagination__item');
        if (!button) {
          return;
        }
        
        if (button.hasAttribute('aria-disabled') && button.getAttribute('aria-disabled') === 'true') {
          return;
        }

        const page = button.getAttribute('data-page');
        if (!page) {
          return;
        }
        
        if (page === 'prev' || page === 'next') {
          const currentPage = BlogState.currentPage;
          const newPage = page === 'prev' ? currentPage - 1 : currentPage + 1;
          if (newPage >= 1) {
            BlogState.currentPage = newPage;
            this.goToPage(newPage);
          }
          return;
        }

        const pageNumber = parseInt(page);
        if (!isNaN(pageNumber) && pageNumber >= 1) {
          BlogState.currentPage = pageNumber;
          this.goToPage(pageNumber);
        }
      });
    }

    static goToPage(page) {
      const container = document.querySelector('[data-ec-blog-results]');
      if (!container) {
        return;
      }
      
      const body = container.querySelector('[data-ec-blog-results-body]');
      if (!body) {
        return;
      }
      
      const grid = body.querySelector('.ec-blog-results__grid');
      if (!grid) {
        return;
      }
      
      if (page < 1) {
        page = 1;
      }

      const perPage = parseInt(container.getAttribute('data-per-page') || String(DEFAULT_PER_PAGE), 10) || DEFAULT_PER_PAGE;
      const allCards = Array.from(grid.querySelectorAll('[data-ec-blog-card]'));
      
      const visibleCards = allCards;
      
      const totalPages = Math.ceil(visibleCards.length / perPage);
      
      if (page > totalPages && totalPages > 0) {
        page = totalPages;
      }

      const startIndex = (page - 1) * perPage;
      const endIndex = startIndex + perPage;

      allCards.forEach(card => {
        card.style.display = 'none';
      });

      visibleCards.forEach((card, index) => {
        if (index >= startIndex && index < endIndex) {
          card.style.display = '';
        }
      });

      BlogState.currentPage = page;
      this.updatePaginationHTML(container, page, totalPages);
    }

    static updatePaginationHTML(container, currentPage, totalPages) {
      const pagination = container.querySelector('.ec-blog-results__pagination');
      if (!pagination) {
        return;
      }
      
      if (totalPages <= 1) {
        pagination.style.display = 'none';
        return;
      }
      
      pagination.style.display = 'block';
      pagination.innerHTML = '';
      
      const nav = document.createElement('nav');
      nav.className = 'pagination';
      nav.setAttribute('role', 'navigation');
      nav.setAttribute('aria-label', 'Paginação');
      
      const ul = document.createElement('ul');
      ul.className = 'pagination__list list-unstyled';
      ul.setAttribute('role', 'list');
      
      const prevLi = document.createElement('li');
      const prevLink = document.createElement('a');
      prevLink.href = '#';
      prevLink.className = 'pagination__item pagination__item--next pagination__item-arrow link motion-reduce';
      if (currentPage === 1) {
        prevLink.classList.add('pagination__item--disabled');
        prevLink.setAttribute('aria-disabled', 'true');
        prevLink.setAttribute('tabindex', '-1');
      }
      prevLink.setAttribute('aria-label', 'Página anterior');
      prevLink.setAttribute('data-page', 'prev');
      prevLink.innerHTML = '<span class="svg-wrapper"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.834 10.0001H4.16732M4.16732 10.0001L7.50065 13.3334M4.16732 10.0001L7.50065 6.66675" stroke="#444444" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
      prevLi.appendChild(prevLink);
      ul.appendChild(prevLi);
      
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);
      let showEllipsisStart = false;
      let showEllipsisEnd = false;
      
      if (totalPages > 7) {
        if (currentPage > 4) {
          showEllipsisStart = true;
          startPage = currentPage - 2;
        } else {
          startPage = 1;
          endPage = 5;
        }
        
        if (currentPage < totalPages - 3) {
          showEllipsisEnd = true;
          endPage = currentPage + 2;
        } else {
          startPage = totalPages - 4;
          endPage = totalPages;
        }
      }
      
      if (showEllipsisStart) {
        const firstLi = document.createElement('li');
        const firstLink = document.createElement('a');
        firstLink.href = '#';
        firstLink.className = 'pagination__item link';
        firstLink.setAttribute('aria-label', 'Página 1');
        firstLink.setAttribute('data-page', '1');
        firstLink.textContent = '1';
        firstLi.appendChild(firstLink);
        ul.appendChild(firstLi);
        
        const ellipsisLi = document.createElement('li');
        const ellipsis = document.createElement('span');
        ellipsis.className = 'pagination__item';
        ellipsis.textContent = '...';
        ellipsisLi.appendChild(ellipsis);
        ul.appendChild(ellipsisLi);
      }
      
      for (let i = startPage; i <= endPage; i++) {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#';
        link.className = 'pagination__item link';
        if (i === currentPage) {
          link.classList.add('pagination__item--current', 'light');
          link.setAttribute('aria-current', 'page');
          link.setAttribute('aria-disabled', 'true');
          link.style.pointerEvents = 'none';
        }
        link.setAttribute('aria-label', `Página ${i}`);
        link.setAttribute('data-page', i.toString());
        link.textContent = i.toString();
        li.appendChild(link);
        ul.appendChild(li);
      }
      
      if (showEllipsisEnd) {
        const ellipsisLi = document.createElement('li');
        const ellipsis = document.createElement('span');
        ellipsis.className = 'pagination__item';
        ellipsis.textContent = '...';
        ellipsisLi.appendChild(ellipsis);
        ul.appendChild(ellipsisLi);
        
        const lastLi = document.createElement('li');
        const lastLink = document.createElement('a');
        lastLink.href = '#';
        lastLink.className = 'pagination__item link';
        lastLink.setAttribute('aria-label', `Página ${totalPages}`);
        lastLink.setAttribute('data-page', totalPages.toString());
        lastLink.textContent = totalPages.toString();
        lastLi.appendChild(lastLink);
        ul.appendChild(lastLi);
      }
      
      const nextLi = document.createElement('li');
      const nextLink = document.createElement('a');
      nextLink.href = '#';
      nextLink.className = 'pagination__item pagination__item--prev pagination__item-arrow link motion-reduce';
      if (currentPage === totalPages) {
        nextLink.classList.add('pagination__item--disabled');
        nextLink.setAttribute('aria-disabled', 'true');
        nextLink.setAttribute('tabindex', '-1');
      }
      nextLink.setAttribute('aria-label', 'Próxima página');
      nextLink.setAttribute('data-page', 'next');
      nextLink.innerHTML = '<span class="svg-wrapper"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.16602 10.0001H15.8327M15.8327 10.0001L12.4993 13.3334M15.8327 10.0001L12.4993 6.66675" stroke="#444444" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
      nextLi.appendChild(nextLink);
      ul.appendChild(nextLi);
      
      nav.appendChild(ul);
      const oldNav = pagination.querySelector('nav');
      if (oldNav) {
        oldNav.remove();
      }
      pagination.appendChild(nav);
    }
  }

  class BlogManager {
    static applyFilters() {
      const container = document.querySelector('[data-ec-blog-results]');
      if (!container) {
        return;
      }
      
      const body = container.querySelector('[data-ec-blog-results-body]');
      if (!body) {
        return;
      }
      
      const grid = body.querySelector('.ec-blog-results__grid');
      if (!grid) {
        return;
      }

      const allCards = Array.from(grid.querySelectorAll('[data-ec-blog-card]'));
      
      if (allCards.length === 0) {
        return;
      }
      
      let visibleCards = Array.from(allCards);

      const tag = BlogState.normalizeString(BlogState.currentTag);
      if (tag) {
        visibleCards = visibleCards.filter(card => {
          const cardTags = card.getAttribute('data-tags') || '';
          const tagsArray = cardTags.split(',').map(t => BlogState.normalizeString(t.trim()));
          return tagsArray.includes(tag);
        });
      }

      const sortedCards = BlogSorting.sortCards(visibleCards);
      
      allCards.forEach(card => {
        card.style.display = 'none';
      });

      sortedCards.forEach((card) => {
        grid.appendChild(card);
        card.style.display = '';
      });

      BlogState.currentPage = 1;
      this.updateGrid(container, sortedCards.length);
    }

    static updateGrid(container, visibleCount) {
      if (!container) {
        container = document.querySelector('[data-ec-blog-results]');
      }
      if (!container) {
        return;
      }
      
      const body = container.querySelector('[data-ec-blog-results-body]');
      if (!body) {
        return;
      }
      
      const perPage = parseInt(container.getAttribute('data-per-page') || String(DEFAULT_PER_PAGE), 10) || DEFAULT_PER_PAGE;
      const grid = body.querySelector('.ec-blog-results__grid');
      if (!grid) {
        return;
      }
      
      const allCards = Array.from(grid.querySelectorAll('[data-ec-blog-card]'));
      const visibleCards = allCards.filter(card => {
        const display = window.getComputedStyle(card).display;
        return display !== 'none';
      });
      
      const totalPages = Math.ceil(visibleCount / perPage);
      const currentPage = BlogState.currentPage || 1;
      const startIndex = (currentPage - 1) * perPage;
      const endIndex = startIndex + perPage;
      
      if (visibleCount === 0) {
        const emptyMessage = body.querySelector('.ec-blog-results__empty');
        if (emptyMessage) {
          emptyMessage.style.display = 'block';
        }
        const pagination = body.querySelector('.ec-blog-results__pagination');
        if (pagination) {
          pagination.style.display = 'none';
        }
        allCards.forEach(card => {
          card.style.display = 'none';
        });
      } else {
        const emptyMessage = body.querySelector('.ec-blog-results__empty');
        if (emptyMessage) {
          emptyMessage.style.display = 'none';
        }

        allCards.forEach(card => {
          card.style.display = 'none';
        });

        visibleCards.forEach((card, index) => {
          const shouldShow = index >= startIndex && index < endIndex;
          if (shouldShow) {
            card.style.display = '';
          }
        });

        BlogPagination.updatePaginationHTML(container, currentPage, totalPages);
      }
    }
  }

  function init() {
    setupSearchBars();
    setupResultLists();
    
    const initFiltersAndPagination = () => {
      const checkAndInit = () => {
        const containerCheck = document.querySelector('[data-ec-blog-results]');
        const buttonCheck = document.getElementById('ec-blog-tag-filter-button');
        
        if (!containerCheck || !buttonCheck) {
          requestAnimationFrame(checkAndInit);
          return;
        }
        
        try {
          BlogFiltering.init();
          BlogSorting.init();
          BlogPagination.init();
          BlogManager.applyFilters();
        } catch (error) {
          console.error(error);
        }
      };
      
      checkAndInit();
    };
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFiltersAndPagination);
    } else {
      setTimeout(initFiltersAndPagination, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

